import Header from './components/Header';
import Hero from './components/Hero';
import Cards from './components/Cards';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import Topics from './components/Topics';
import About from './components/About';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Faq from './components/Faq';
import Index from './components/Index';
import Media from './components/Media';
import Ranking from './components/Ranking';
import App from './components/App';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Cards />
        <Features />
        <Carousel />
        <Comments />
        <Topics />
        <About />
        <Contact />
        <Updates />
        <Faq />
        <Index />
        <Media />
        <Ranking />
        <App />
      </main>
      <Footer />
    </div>
  );
}